const firstMessage = (messages) => {
  if (Array.isArray(messages)) return messages[0] || "";
  return typeof messages === "string" ? messages : "";
};

const getResponseErrors = (error) => error?.response?.data?.errors || {};

const getFallbackMessage = (error) => {
  if (typeof error?.response?.data?.message === "string") {
    return error.response.data.message;
  }
  const errors = getResponseErrors(error);
  const firstKey = Object.keys(errors)[0];
  return firstKey ? firstMessage(errors[firstKey]) : "";
};

export const mapRegistrationErrors = (error) => {
  const errors = getResponseErrors(error);
  const fieldErrors = {};

  if (errors.firstname) fieldErrors.firstname = firstMessage(errors.firstname);
  if (errors.first_name) fieldErrors.firstname = firstMessage(errors.first_name);
  if (errors.lastname) fieldErrors.lastname = firstMessage(errors.lastname);
  if (errors.last_name) fieldErrors.lastname = firstMessage(errors.last_name);
  if (errors.email) fieldErrors.email = firstMessage(errors.email);
  if (errors.phone) fieldErrors.phone = firstMessage(errors.phone);
  if (errors.birthdate) fieldErrors.birthdate = firstMessage(errors.birthdate);
  if (errors.birth_date) fieldErrors.birthdate = firstMessage(errors.birth_date);
  if (errors.civility) fieldErrors.civility = firstMessage(errors.civility);
  if (errors.password) fieldErrors.password = firstMessage(errors.password);
  if (errors.confirmPassword) {
    fieldErrors.confirmPassword = firstMessage(errors.confirmPassword);
  } else if (errors.confirm_password) {
    fieldErrors.confirmPassword = firstMessage(errors.confirm_password);
  }
  if (errors.acceptCGU) {
    fieldErrors.acceptCGU = firstMessage(errors.acceptCGU);
  } else if (errors.accept_cgu) {
    fieldErrors.acceptCGU = firstMessage(errors.accept_cgu);
  }

  return {
    fieldErrors,
    globalMessage: getFallbackMessage(error),
  };
};

export const mapOtpErrors = (error) => {
  const errors = getResponseErrors(error);
  const fieldErrors = {};

  if (errors.phone) fieldErrors.phone = firstMessage(errors.phone);
  if (errors.phone_number) fieldErrors.phone = firstMessage(errors.phone_number);
  if (errors.otp) {
    fieldErrors.otp = firstMessage(errors.otp);
  } else if (errors.code) {
    fieldErrors.otp = firstMessage(errors.code);
  } else if (errors.otp_code) {
    fieldErrors.otp = firstMessage(errors.otp_code);
  }

  return {
    fieldErrors,
    globalMessage: getFallbackMessage(error),
  };
};
